var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20704",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2",
    transform: "translate(.667 .667)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11814",
    d: "M9.333 2a7.3 7.3 0 1 0 5.2 2.138A7.333 7.333 0 0 0 9.333 2zm0 13.333a6 6 0 1 1 6-6 6 6 0 0 1-6 6z",
    transform: "translate(-2 -2)",
    style: {
      fill: "#696c80"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11815",
    d: "M22.667 20a.667.667 0 0 0-.667.667v4a.667.667 0 1 0 1.333 0v-4a.667.667 0 0 0-.666-.667z",
    transform: "translate(-15.333 -14)",
    style: {
      fill: "#696c80"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 925",
    cx: 0.667,
    cy: 0.667,
    r: 0.667,
    transform: "translate(6.667 3.333)",
    style: {
      fill: "#696c80"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon2);
export default __webpack_public_path__ + "static/media/HelpIcon2.af2df00a.svg";
export { ForwardRef as ReactComponent };